<template>
  <div class="home">
    <h1 class="title">首页</h1>
    <div class="menu">
      <router-link v-for="route in routes.filter(r => r.path !== '/')" :key="route.path" :to="route.path" class="button">
        {{ route.name }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { routes } from '../router/index'
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-family: 'Arial', sans-serif;
}

.title {
  font-size: 3rem;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.button {
  display: inline-block;
  padding: 1rem 2rem;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  text-align: center;
  font-size: 1.2rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}
</style>
